function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "outbound");

var _ref3 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "\\u2693\\uFE0F-The-Shipyard",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "\\u260DQronoport-/-Foundation-/-activities-/-vessel-departure",
  transform: "translate(-4.000000, -2.000000)",
  fill: "#06273A"
}, React.createElement("path", {
  d: "M15.29,16.2898338 L13,18.5898071 L13,6.99994185 C13,6.44766353 12.5522847,5.99995348 12,5.99995348 C11.4477153,5.99995348 11,6.44766353 11,6.99994185 L11,18.5898071 L8.71,16.2898338 C8.31787783,15.8977162 7.68212217,15.8977162 7.29,16.2898338 C6.89787783,16.6819514 6.89787783,17.3176997 7.29,17.7098173 L11.29,21.7097708 C11.3851037,21.8008104 11.4972487,21.8721745 11.62,21.9197683 C11.8620399,22.0267439 12.1379601,22.0267439 12.38,21.9197683 C12.5027513,21.8721745 12.6148963,21.8008104 12.71,21.7097708 L16.71,17.7098173 C17.1021222,17.3176997 17.1021222,16.6819514 16.71,16.2898338 C16.3178778,15.8977162 15.6821222,15.8977162 15.29,16.2898338 L15.29,16.2898338 Z M19,2 L5,2 C4.44771525,2 4,2.44771004 4,2.99998837 C4,3.5522667 4.44771525,3.99997674 5,3.99997674 L19,3.99997674 C19.5522847,3.99997674 20,3.5522667 20,2.99998837 C20,2.44771004 19.5522847,2 19,2 Z",
  id: "outbound",
  transform: "translate(12.000000, 12.000000) scale(1, -1) translate(-12.000000, -12.000000) "
})));

var SvgOutbound = function SvgOutbound(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "16px",
    height: "20px",
    viewBox: "0 0 16 20",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgOutbound, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/outbound.11ae77f7.svg";
export { ForwardRef as ReactComponent };